<template>
  <div v-if="userID === 7">
    <div class="modal fade" id="changeStatusModal" ref="modalEle" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień status wybranych wierszy zamówienia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>
			<div class="row">
			  <div class="col-md-3">
              <label for="project-select">Wybierz status:</label>
              <select id="project-select" class="form-select form-select-sm" @focus="rememberPreviousStatus"
                      @change="updateSelectedStatus"
                      v-model="newSelectedStatus">
                <option v-for="status in statuses" :value="status.id"> {{ status.name }}</option>
              </select>
            </div>
            </div>
			<div class="table-responsive mt-5">
			  <table class="table table-striped">
				<tbody>
				  <template v-for="group in groupedOrders" :key="group.order_number">
					<tr
					  @click="toggleOrder(group.order_number)" style="cursor: pointer; background-color: #f8f9fa; font-weight: 600;">
					  <td colspan="10">
						📦 Nr zamówienia: {{ group.order_number }}
						<span class="float-end">
						  {{ expandedOrders[group.order_number] ? '▲' : '▼' }}
						</span>
					  </td>
					</tr>
					<tr v-if="expandedOrders[group.order_number]">
					  <td colspan="10" class="p-0">
						<table class="table table-sm table-bordered mb-0">
						 <thead>
							<tr>
							  <th>Nr zam.</th>
							  <th>Nr poz.</th>
							  <th>Podzespół nr rysunku</th>
							  <th>Nr katalogowy</th>
							  <th>Nazwa/Opis</th>
							  <th>Ilość zamawiana</th>
							  <th>Status</th>
							</tr>
						  </thead>
						  <tbody>
							<tr v-for="record in group.records" :key="record.id" :class="{ 'text-muted text-decoration-line-through': isCancelled(record) }">
							  <td>{{ record.order_list?.order_number ?? '' }}</td>
							  <td>{{ record.id }}</td>
							  <td>{{ record.subteam_drawing_no }}</td>
							  <td>{{ record.article?.catalog_number || '' }}</td>
							  <td>{{ record.article?.description || record.article?.model}}</td>
							  <td>{{ record.quantity_required }}</td>
							  <td>{{ record.status?.name ?? record.status ?? '' }}</td>
							</tr>
						  </tbody>
						</table>
					  </td>
					</tr>
				  </template>
				</tbody>
			  </table>
			</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div v-else>
    <div class="modal fade" id="changeStatusModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień status wybranych wierszy zamówienia</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>
			<div class="row">
			  <div class="col-md-3">
               <label for="project-select">Wybierz status:</label>
              <select id="project-select" class="form-select form-select-sm" @focus="rememberPreviousStatus"
                      @change="updateSelectedStatus"
                      v-model="newSelectedStatus">
                <option v-for="status in statuses" :value="status.id"> {{ status.name }}</option>
              </select>
            </div>
             </div>
           <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th @click="sortBy('order_list?.order_number')" style="cursor:pointer;">Nr zam.</th>
                  <th @click="sortBy('id')" style="cursor:pointer;">Nr poz.</th>
                  <th @click="sortBy('article?.catalog_number')" style="cursor:pointer;">Nr katalogowy</th>
                  <th @click="sortBy('article?.model')" style="cursor:pointer;">Model</th>
                  <th @click="sortBy('article?.description')" style="cursor:pointer;">Nazwa/Opis</th>
                  <th style="cursor:pointer;">J.m.</th>
                  <th @click="sortBy('quantity_required')" style="cursor:pointer;">Ilość zamawiana</th>
                  <th @click="sortBy('delivered_quantity')" style="cursor:pointer;">Ilość dostarczona</th>
                  <th @click="sortBy('comments')" style="cursor:pointer;">Uwagi</th>
                  <th @click="sortBy('status?.name')" style="cursor:pointer;">Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in sortedEntries" :key="record.id" :class="{ 'text-muted text-decoration-line-through': isCancelled(record) }">
                  <td>{{ record.order_list?.order_number ?? '' }}</td>
                  <td>{{ record.id }}</td>
                  <td>{{ record.article?.catalog_number || '' }}</td>
                  <td>{{ record.article?.model }}</td>
                  <td>{{ record.article?.description }}</td>
                  <td>{{ record.article?.article_unit?.name ?? '' }}</td>
                  <td>{{ record.quantity_required }}</td>
                  <td>
                    <template v-if="['Zamówienie wysłane', 'Częściowo zrealizowane', 'Zrealizowane'].includes(newSelectedStatusName) && !isCancelled(record)">
<input
    type="number"
    :step="record.article?.article_unit?.allow_decimal == 1 ? '0.01' : '1'"
    min="0"
    class="form-control form-control-sm"
    v-model.number="record.delivered_quantity"
    :max="record.delivered_quantity"
    @keydown="!record.article?.article_unit?.allow_decimal && ['.', ',', 'e', 'E'].includes($event.key) && $event.preventDefault()"
    style="max-width: 100px"
/>
                    </template>
                    <template v-else>
                      {{ record.delivered_quantity }}
                    </template>
				  </td>
                  <td>{{ record.comments }}</td>
                  <td>{{ record.status?.name ?? record.status ?? '' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from "bootstrap";
import { router } from '@inertiajs/vue3';

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
computed: {
  newSelectedStatusName() {
    const selected = this.statuses.find(
      s => s.id === Number(this.newSelectedStatus)
    );

    return selected ? selected.name : '';
  },

  groupedOrders() {
    const groups = {};

    (this.selectedRecords || []).forEach(record => {
      const orderNo = record.order_list?.order_number ?? 'BRAK';

      if (!groups[orderNo]) {
        groups[orderNo] = {
          order_number: orderNo,
          records: []
        };
      }

      groups[orderNo].records.push(record);
    });

    return Object.values(groups);
  },

  sortedEntries() {
    const records = [...(this.selectedRecords || [])];

    if (!this.sortColumn) {
      return records;
    }

    const getValue = (obj, path) => {
      return path
        .replaceAll('?.', '.')
        .split('.')
        .reduce((value, key) => value?.[key], obj);
    };

    return records.sort((a, b) => {
      let aVal = getValue(a, this.sortColumn);
      let bVal = getValue(b, this.sortColumn);

      // puste wartości na końcu
      if (aVal == null || aVal === '') return 1;
      if (bVal == null || bVal === '') return -1;

      // liczby sortujemy numerycznie
      const aNum = Number(aVal);
      const bNum = Number(bVal);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return this.sortDirection === 'asc'
          ? aNum - bNum
          : bNum - aNum;
      }

      // tekst
      aVal = String(aVal).toLowerCase();
      bVal = String(bVal).toLowerCase();

      if (aVal < bVal) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }

      if (aVal > bVal) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }

      return 0;
    });
  }
},

  props: {
    selectedRecords: Array,
    statuses: Object,
	userID: Number
  },

  watch: {
selectedRecords: {
    handler(newVal) {
      if (newVal && newVal.length) {
        this.newSelectedStatus = null
        this.error = null

        this.originalDeliveredQuantities = {}

        newVal.forEach(record => {
          this.originalDeliveredQuantities[record.id] = Number(record.delivered_quantity)
        })
      }
    },
    immediate: true
  }
  },

  data() {
    return {
      previousStatus: null,
      newSelectedStatus: null,
      error: null,
    originalDeliveredQuantities: {},
	expandedOrders: {} ,
	                sortColumn: '',
                sortDirection: 'asc'
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
		  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  methods: {
      sortBy(column) {
      if (this.sortColumn === column) {
		this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
		this.sortColumn = column;
		this.sortDirection = 'asc';
      }
	}, 
   toggleOrder(orderNumber) {
    this.expandedOrders[orderNumber] = !this.expandedOrders[orderNumber];
  },
  
updateSelectedStatus(event) {
  this.newSelectedStatus = event.target.value;
},
isCancelled(record) {
  const statusName = record.status?.name ?? record.status ?? '';
  return statusName === 'Anulowane';
},
 async submitForm() {


const modifiedRecords = this.selectedRecords
  .filter(record =>
    Number(record.delivered_quantity) !==
    Number(this.originalDeliveredQuantities[record.id])
  )
  .map(record => ({
    id: record.id,
    delivered_quantity: record.delivered_quantity
  }));

  const records = this.selectedRecords || [];
  const activeRecords = records.filter(item => !this.isCancelled(item));
  /*
  let recordsToUpdate = activeRecords.map(item => ({
    id: item.id,
    newStatus: Number(this.newSelectedStatus),
    delivered_quantity: item.delivered_quantity
  }));
*/
let recordsToUpdate = activeRecords.map(item => ({
    id: item.id,
    newStatus: Number(this.newSelectedStatus),
    delivered_quantity: item.delivered_quantity,
    previous_delivered_quantity: Number(this.originalDeliveredQuantities[item.id] ?? 0)
}));
  const isRealized = Number(this.newSelectedStatus) === 4;

  if (isRealized && !this.allDeliveryQuantityDispatched(activeRecords)) {
    await Toast.fire({
      toast: false,
      position: 'center',
      icon: 'warning',
      title: 'Zakończenie zamówienia',
      html: 'Aby dokończyć realizacje zamówienia, dostarczona ilość oraz wydana ilość musi być taka sama.',
      showClass: {popup: 'animate__animated animate__fadeInDown'},
      hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      timer: false,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Ok, rozumiem',
    });

    this.newSelectedStatus = this.previousStatus;
    return;
  }

  // =========================
  // CONFIRM "ZREALIZOWANE"
  // =========================
  if (isRealized) {
    const result = await Toast.fire({
      toast: false,
      position: 'center',
      icon: 'question',
      title: 'Zakończenie zamówienia',
      html: 'Czy na pewno chcesz zmienić status na zrealizowany?',
      showClass: {popup: 'animate__animated animate__fadeInDown'},
      hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      timer: false,
      showConfirmButton: true,
      confirmButtonText: 'Tak',
      confirmButtonColor: 'success',
      showCancelButton: true,
      cancelButtonText: 'Nie',
    });

    if (result.isConfirmed) {
      this.changeStatus(recordsToUpdate);
    }

    return;
  }

  this.changeStatus(recordsToUpdate);
},

changeStatus(records) {

  axios.post(route('quoteRequests.change-status'), {
    records
  })
.then(() => {

  this.$emit('added-success', 'Zmieniono status poprawnie');
  this.$emit('updated-article', true);
  this.$emit('clear-selection');
  this.hide();

const changedRecords = this.selectedRecords.filter(record => {

  const oldQty = Number(this.originalDeliveredQuantities[record.id]);
  const newQty = Number(record.delivered_quantity);
  const qtyChanged = oldQty !== newQty;
  return qtyChanged; // 👈 TYLKO TO
});

  const requiredProjectIds = changedRecords
    .flatMap(record => {

      const v = record.required_project_items_id;

      if (!v) return [];
      if (Array.isArray(v)) return v;

      return String(v).split(',');
    })
    .map(id => Number(id))
    .filter(Number.isFinite);

  const ids = [...new Set(requiredProjectIds)];

  if (ids.length) {

    const url = route('requiredProjectItems.index', {
      ids: ids.join(',')
    });

    router.get(url);

  } else {
    console.warn('❌ BRAK IDS -> NIE MA PRZEKIEROWANIA');
  }

})
  .catch(error => {
    this.error = error.response?.data;
    console.log('error', error);
  });
},

allDeliveryQuantityDispatched(records = this.selectedRecords) {
  return records
    .filter(item => !this.isCancelled(item))
    .every(item =>
      Number(item.delivered_quantity) === Number(item.quantity_required)
    );
},	
    rememberPreviousStatus() {
      this.previousStatus = this.newSelectedStatus;
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>
